import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { AppService } from 'app/services/app/app.service';
import { RestService } from '../../services/rest/rest.service';
import { CommissionsModel, MyCommissionsModel } from 'app/models/my-commissions-model';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { MyCommissionsDialogComponent } from './my-commissions-dialog.component';
import { AuxDialogComponent } from './aux-dialog.component';

@Component({
    selector: 'app-my-commissions',
    templateUrl: './my-commissions.component.html',
    styleUrls: ['./my-commissions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MyCommissionsComponent implements OnInit {

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  displayedColumns: string[] = ['createdAt', 'totalPurchased', 'percentage', 'liquidated', 'invoice'];
  myCommissions: MyCommissionsModel = {
    requestPayment: false,
    lastPayment: 0,
    nextPayment: 0,
    commissions: undefined
  };
  commissions = new MatTableDataSource<CommissionsModel>([]);

  constructor(
    private appService: AppService, 
    private restService: RestService, 
    private dialog: MatDialog) { 

  }

  ngOnInit() {
    this.getMyCommissions();

    this.commissions.filterPredicate = (dato: CommissionsModel, filtro: string) => {
      const textoTransformado = `
        ${new Intl.DateTimeFormat('es-ES').format(dato.createdAt)}
        ${dato.totalPurchased.toFixed(2)}€
        ${dato.percentage}%
        ${dato.liquidated ? this.appService.getTraduccion('myCommissions.status.true') : this.appService.getTraduccion('myCommissions.status.false')}
        ${dato.invoice}
      `.toLowerCase();

      return textoTransformado.includes(filtro.trim().toLowerCase());
    };

  }

  ngAfterViewInit() {
    this.commissions.paginator = this.paginator;
    this.commissions.sort = this.sort;
  }

  openInvoiceDialog() {
    this.dialog.open(MyCommissionsDialogComponent, {
      width: '650px',
      maxHeight: '90vh'
    });
  }
  
  openAuxDialog(title:string, msg:string) {
    this.dialog.open(AuxDialogComponent, {
      width: '650px',
      maxHeight: '90vh',
      data: {title: title, message: msg}
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.commissions.filter = filterValue.trim().toLowerCase();
  }

  getMyCommissions(){
    this.restService.getMyCommissions().subscribe(result => {
      this.myCommissions = this.normalizeMyCommissions(result);
      this.commissions.data = this.myCommissions.commissions?.content ?? [];
    });
  }

  private normalizeMyCommissions(result: Partial<MyCommissionsModel> | null | undefined): MyCommissionsModel {
    return {
      requestPayment: result?.requestPayment ?? false,
      lastPayment: result?.lastPayment ?? 0,
      nextPayment: result?.nextPayment ?? 0,
      commissions: result?.commissions ?? undefined
    };
  }

  commissionTransfer(){
    if (!confirm(this.appService.getTraduccion('myCommissions.transferWallet.confirm'))) {
      return;
    }
    this.restService.commissionTransfer().subscribe(result => {
      this.getMyCommissions();
    });
  }

}
